document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('shBenefitsSlider');
  if (!root) return;

  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
  if (slides.length === 0) return;

  var dotsContainer = document.getElementById('shBsDots');
  var prevBtn = document.getElementById('shBsPrev');
  var nextBtn = document.getElementById('shBsNext');
  var current = 0;
  var timer = null;
  var AUTOPLAY_MS = 6000;

  slides.forEach(function (slide, i) {
    var dot = document.createElement('button');
    dot.className = 'sh-bs__dot' + (i === 0 ? ' is-active' : '');
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    dot.addEventListener('click', function () { goTo(i); resetAutoplay(); });
    dotsContainer.appendChild(dot);
  });
  var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.sh-bs__dot'));

  function goTo(index) {
    slides[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    dots[current].classList.add('is-active');
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startAutoplay() {
    if (AUTOPLAY_MS <= 0) return;
    timer = setInterval(next, AUTOPLAY_MS);
  }
  function resetAutoplay() {
    if (timer) clearInterval(timer);
    startAutoplay();
  }

  prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });
  nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });

  root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
  root.addEventListener('mouseleave', startAutoplay);

  startAutoplay();
});
